// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { connect, ResolveThunks } from "react-redux";
import { css, withTheme } from "styled-components";
import HeaderLink, { HeaderLinkStyles } from "@store/Library/Components/Toolkit/HeaderLink";
import { countBubbleStyles } from "@store/Themes/common/mixins/countBubble";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC, useEffect, useMemo } from "react";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import getColor from "@insite/mobius/utilities/getColor";
import QuoteLink, { QuoteLinkOffset } from "@store/Library/Components/Toolkit/Icons/QuoteLink";

const mapStateToProps = (state: ApplicationState) => ({
    shouldLoadCart: !getCurrentCartState(state).value && !getCurrentCartState(state).isLoading,
    totalCountDisplay: getCurrentCartState(state).value?.totalCountDisplay,
    cartUrl: getPageLinkByPageType(state, "CartPage")?.url,
});

const mapDispatchToProps = {
    loadCurrentCart,
};

export interface CartLinkStyles {
    routerLink?: LinkPresentationProps;
    desktopCountText?: TypographyPresentationProps;
    mobileCountText?: TypographyPresentationProps;
    compactCountText?: TypographyPresentationProps;
    headerLink?: HeaderLinkStyles;
}

export const cartLinkStyles: CartLinkStyles = {
    mobileCountText: {
        css: css`
            ${countBubbleStyles(pxToRemArray([-8, -10]), "tertiary")};

            border: none;
            color: ${getColor("swatch.black")};
            width: ${pxToRem(22)};
            height: ${pxToRem(22)};
            padding: ${pxToRem(5)};
        `,
    },
    headerLink: {
        link: {
            icon: {
                iconProps: {
                    css: css`
                        ${breakpoint("md")} {
                            svg {
                                padding: 8px;
                                margin: 0 !important;
                                color: ${getColor("header.accentContrast")};
                                transform: translate(-5px, -2px);
                            }
                        }
                    `,
                },
            },
            typographyProps: {
                weight: 600,
            },
            css: css`
                background-color: ${getColor("header.accent")};
                color: ${getColor("header.accentContrast")};
                padding: ${pxToRem(5, 14, 5, 10)};
                border-radius: ${pxToRem(4)};

                &:hover {
                    color: ${getColor("header.accentContrast")};
                    background-color: ${getColor("header.contrast")};
                }
            `,
            mergeCss: true,
        },
        innerWrapper: {
            css: css`
                margin-left: 0;
            `,
        },
    },
};

interface OwnProps extends WidgetProps {
    isCompactHeaderCart?: boolean;
    theme: BaseTheme;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

/** Reloading the cart makes `totalCountDisplay` temporarily unavailable, so retain the previous value for better UX. */
let retainedTotalCountToDisplay = 0;

const CartLink: FC<Props> = ({
    shouldLoadCart,
    cartUrl,
    totalCountDisplay,
    // fields: { visibilityState, icon: selectedIcon },
    loadCurrentCart,
    // isCompactHeaderCart,
    // theme,
}) => {
    useEffect(() => {
        if (shouldLoadCart) {
            loadCurrentCart({ shouldLoadFullCart: false, replaceCart: false });
        }
    }, [shouldLoadCart]);

    if (typeof totalCountDisplay !== "undefined") {
        retainedTotalCountToDisplay = totalCountDisplay;
    }

    const styles = useMergeStyles("cartLink", cartLinkStyles);

    return (
        <HeaderLink
            href={cartUrl}
            iconSrc={QuoteLink}
            iconOffset={QuoteLinkOffset}
            label={translate("Quote")}
            extendedStyles={styles.headerLink}
            data-test-selector="quoteLink"
        >
            {retainedTotalCountToDisplay ? (
                <Typography {...styles.mobileCountText} aria-hidden="true">
                    {retainedTotalCountToDisplay}
                </Typography>
            ) : null}
        </HeaderLink>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withTheme(CartLink)),
    definition: {
        displayName: "Quote Link",
        icon: "cart-shopping",
        group: "Common",
    },
};

export default widgetModule;
